<script lang="ts">
import { defineComponent as __MACROS_defineComponent } from "vue";
export default /*#__PURE__*/ __MACROS_defineComponent({
  name: 'FormationsBusinessDeveloper'
});
</script>
<template>
  <ka-container
    code="prog-05-business-dev"
    :data="page.$info.prog05BusinessDev">
    <!-- Page formation - V -->
    <ka-container code="page-formation-v">
      <PFormationEntete
        instance-class="p-formation-entete--p51"
        h-1="Formation en business development"
        texte="La formation est réalisée par un<strong> expert en business development</strong> issu d'une entreprise à succès." />
      <!-- Container experts -->
      <ka-container code="container-experts">
        <ka-text code="titre">
          <span v-html="t('prog05BusinessDev.pageFormationV.containerExperts.titre.value', `Nos experts en business development`)" />
        </ka-text>
        <ka-text code="texte">
          <span v-html="t('prog05BusinessDev.pageFormationV.containerExperts.texte.value', `Parmi nos 600 experts, une partie d’entre eux est spécialisée dans le développement commercial. Familier des petites entreprises, au cours de leur carrière, ils ont connu et même provoqué, pour certains, une croissance nécessitant le recrutement de nouveaux business developer. Ayant recruté et formé des équipes de business developer dans leur poste, ils souhaitent partager en parallèle de leur activité leur savoir-faire. Pour booster la croissance de votre entreprise, ils vous aideront à fixer et suivre vos objectifs ainsi que mettre en place toutes les actions nécessaires pour les atteindre.`)" />
        </ka-text>
        <!-- Container -->
        <ka-container code="container">
          <BlocPreviewProfilExpert
            instance-class="bloc-preview-profil-expert--p51"
            :options="{
              href: `https://www.matchers.fr/expert/398`,
              ariaLabel: `bloc preview profil expert`,
              click: page.blocPreviewProfilExpertClick
            }"
            :tags="page.$constants.blocPreviewProfilExpertTags"
            poste="Responsable commercial"
            first-name="Geoffroy"
            enttreprise="&#64;Doctolib"
            image="https://ucarecdn.com/93f5fa26-929c-4a42-b321-9085fc3f75f8/" />
          <BlocPreviewProfilExpert
            instance-class="element-1--p51"
            :options="{
              href: `https://www.matchers.fr/expert/135`,
              ariaLabel: `bloc preview profil expert`,
              click: page.element1Click
            }"
            :xs="{ hidden: null }"
            :tags="page.$constants.element1Tags"
            poste="Directeur commercial"
            first-name="Nicolas"
            enttreprise="&#64;NoCRM"
            image="https://ucarecdn.com/868761a2-7582-4b28-a282-ee15e38857d3/" />
          <BlocPreviewProfilExpert
            instance-class="element-2--p51"
            :xs="{ hidden: null }"
            :tags="page.$constants.element2Tags"
            poste="Commercial grands comptes"
            first-name="Stanislas"
            enttreprise="&#64;Deepki"
            image="https://ucarecdn.com/3c6011cb-ea36-447b-9308-3d61a83be540/" />
          <BlocPreviewProfilExpert
            instance-class="element-3--p51"
            :tags="page.$constants.element3Tags"
            poste="Head of sales"
            first-name="Camille"
            enttreprise="&#64;Reality"
            image="https://ucarecdn.com/dc07ec9d-6c19-4033-b2df-6d372816126b/" />
        </ka-container>
        <ka-text
          code="voir"
          :options="{
            href: `https://www.matchers.fr/experts`,
            ariaLabel: `voir`,
            click: page.voirClick
          }">
          <span v-html="t('prog05BusinessDev.pageFormationV.containerExperts.voir.value', `Voir plus de profils >`)" />
        </ka-text>
      </ka-container>
      <!-- Container programme -->
      <ka-container code="container-programme">
        <!-- Container gauche -->
        <ka-container code="container-gauche">
          <!-- Container programme de formation -->
          <ka-container code="container-programme-de-formation">
            <!-- Titre exemple de programme -->
            <ka-container code="titre-exemple-de-programme">
              <ka-text code="voici-un-exemple-de">
                <h2 v-html="t('prog05BusinessDev.pageFormationV.containerProgramme.containerGauche.containerProgrammeDeFormation.titreExempleDeProgramme.voiciUnExempleDe.value', `Voici un exemple de programme de formation`)" />
              </ka-text>
            </ka-container>
            <!-- Module1 -->
            <ka-container code="module-1">
              <ka-text code="determiner-sa-strategie">
                <h2 v-html="t('prog05BusinessDev.pageFormationV.containerProgramme.containerGauche.containerProgrammeDeFormation.module1.determinerSaStrategie.value', `Déterminer sa stratégie commerciale`)" />
              </ka-text>
              <!-- Container -->
              <ka-container code="container-1" />
            </ka-container>
            <!-- Sections déroulantes -->
            <ka-container code="sections-deroulantes">
              <!-- Conteneur section -->
              <ka-container code="conteneur-section">
                <DropDownFormation
                  instance-class="drop-down-formation--p51"
                  titre="I.   Orienter sa stratégie commerciale"
                  :arguments="page.$constants.dropDownFormationArguments" />
              </ka-container>
              <!-- Conteneur section -->
              <ka-container code="container-2">
                <DropDownFormation
                  instance-class="element-4--p51"
                  titre="II.   Affiner son plan d’action commercial"
                  :arguments="page.$constants.element4Arguments" />
              </ka-container>
              <!-- Conteneur section -->
              <ka-container code="container-3">
                <DropDownFormation
                  instance-class="element-5--p51"
                  titre="III.   Construire un tunnel de conversion efficace"
                  :arguments="page.$constants.element5Arguments" />
              </ka-container>
            </ka-container>
            <!-- Module2 -->
            <ka-container code="module-2">
              <ka-text code="les-leviers-de-sa-strategie">
                <h2 v-html="t('prog05BusinessDev.pageFormationV.containerProgramme.containerGauche.containerProgrammeDeFormation.module2.lesLeviersDeSaStrategie.value', `Les leviers de sa stratégie commerciale`)" />
              </ka-text>
              <!-- Container -->
              <ka-container code="container-4" />
            </ka-container>
            <!-- Module2 -->
            <ka-container
              code="container-5"
              :options="{ hidden: true }"
              :xs="{ hidden: false }">
              <ka-text code="text-1">
                <h2 v-html="t('prog05BusinessDev.pageFormationV.containerProgramme.containerGauche.containerProgrammeDeFormation.container5.text1.value', `Module 1`)" />
                <template #xs>
                  <h2 v-html="t('prog05BusinessDev.pageFormationV.containerProgramme.containerGauche.containerProgrammeDeFormation.container5.text1.xs.value', `Module 2`)" />
                </template>
              </ka-text>
              <!-- Container -->
              <ka-container code="container-6" />
            </ka-container>
            <!-- Sections déroulantes -->
            <ka-container code="container-7">
              <!-- Conteneur section -->
              <ka-container code="container-8">
                <DropDownFormation
                  instance-class="element-6--p51"
                  titre="I.   Utiliser l’emailing pour vendre"
                  :arguments="page.$constants.element6Arguments" />
              </ka-container>
              <!-- Conteneur section -->
              <ka-container code="container-9">
                <DropDownFormation
                  instance-class="element-7--p51"
                  titre="II.   Du hunting au closing"
                  :arguments="page.$constants.element7Arguments" />
              </ka-container>
              <!-- Conteneur section -->
              <ka-container code="container-10">
                <DropDownFormation
                  instance-class="element-8--p51"
                  titre="III.   La conversion par le phoning"
                  :arguments="page.$constants.element8Arguments" />
              </ka-container>
              <!-- Conteneur section -->
              <ka-container code="container-11">
                <DropDownFormation
                  instance-class="element-9--p51"
                  titre="IV.   Pérenniser l’activité commerciale"
                  :arguments="page.$constants.element9Arguments" />
              </ka-container>
            </ka-container>
          </ka-container>
          <CtaProgrammeSurMesurePrendreRdv instance-class="cta-programme-sur-mesure-prendre-rdv--p51" />
        </ka-container>
        <BlocArgCtaRdvPedagogieMatchers
          instance-class="bloc-arg-cta-rdv-pedagogie-matchers--p51"
          :xs="{ hidden: null }"
          expert-1="https://ucarecdn.com/317c648e-e707-43df-8f87-df66b9823bdf/profil_expert_Anne-Sophie.svg" />
      </ka-container>
      <BlocArgPasDeFraisPasDeDemarchesAdministratives instance-class="bloc-arg-pas-de-frais-pas-de-demarches-admi--p51" />
      <PFormationMatching
        instance-class="p-formation-matching--p51"
        description-company="<strong>Medelse</strong> | Plateforme mettant en relation les professionnels de santé libéraux avec les établissements de santé.<br> <br> <br><strong>Besoin : </strong>Structurer l'acquisition d’établissements de santé."
        expert-text="<strong>Bastien </strong>| Directeur Régional | &#64;Doctolib.<br> <br> <br><strong>Expertise : </strong>10 ans d'expérience dans la vente de logiciels, maitrise de cycles longs avec le monde médical hospitalier."
        budget-available="10 800€"
        training-hours="63h"
        photo-expert="https://ucarecdn.com/4a1644a2-b382-4307-8ff1-647f22a39819/"
        image="https://ucarecdn.com/9a8847d7-2afc-46fb-a97b-11148d211dfe/" />
      <BlocReassuranceQualiopi instance-class="bloc-reassurance-qualiopi--p51" />
      <PFormationCriteresQualiopi instance-class="p-formation-criteres-qualiopi--p51" />
      <PFormationPourquoiSeFormer
        instance-class="p-formation-pourquoi-se-former--p51"
        text="Pourquoi se former en business development avec Matchers ?"
        text-1="Aujourd'hui, trouver un bon business developer s’avère être un processus compliqué. Si dans les rangs de votre entreprise les profils sont plutôt juniors ou les résultats à la marge, une formation pourrait bien <strong>faire grimper votre activité</strong> !"
        image="https://ucarecdn.com/60f4f78a-2934-4976-b4d6-2dc448af3dd4/" />
      <!-- Sections du domaine -->
      <ka-container code="sections-du-domaine">
        <PFormationSectionBleu
          instance-class="p-formation-section-bleu--p51"
          paragraph="Résumer son offre en une phrase et trouver les mots qui résonnent pour votre cible n’est pas toujours facile. Le point de vue extérieur d’un spécialiste en business development vous aidera à prendre du recul. Vous ne pouvez pas convaincre en 30 min, personne n’a 30 minutes à consacrer à une entreprise ou une offre qu’il ne connaît pas. Avec l’aide d’un expert, vous apprendrez à <strong>résumer votre offre et l’adapter en fonction de votre interlocuteur.</strong> Pour aider votre équipe, ce pitch peut être rédigé et décliné.<br> <br>En vous formant aux méthodes de business development vous saurez comment élaborer un <strong>discours commercial</strong> original, captivant et efficace pour vous différencier et gagner la confiance de vos prospects."
          title="Avant de vouloir prospecter il faut savoir quoi dire !"
          picture="https://ucarecdn.com/c46501b4-e4da-403a-a41c-6880a7f8eff3/" />
        <PFormationSectionVariante
          instance-class="p-formation-section-variante--p51"
          title="<strong>Un argumentaire béton à diffuser sur les bons canaux</strong>" />
        <PFormationSectionBleu
          instance-class="element-10--p51"
          paragraph="Le phoning est un outil très puissant pour <strong>établir des contacts</strong> et <strong>générer des opportunités commerciales</strong>. Le coaching de l’un de nos experts peut vous aider à constituer des listes de prospects qualifiés, passer les barrières de votre interlocuteur et surtout gérer la relation après l’appel téléphonique.<br> <br>Et oui, convaincre ne suffit pas. Imaginons que lors d’un appel téléphonique, vous arrivez à convaincre mais le lead se perd dans la suite du process. Personne ne le suit vraiment et finalement il n’y a aucune vente qui aboutit malgré une opportunité. Tout ce workflow doit être réfléchi et communiqué à vos équipes pour savoir qui fait quoi et à quel moment. La mise en place d’un <strong>outil CRM</strong> peut, par exemple, résoudre des problématiques de communication entre les différents collaborateurs de votre équipe."
          title="Le phoning, pas seulement un appel téléphonique"
          picture="https://ucarecdn.com/c1727c68-65e9-40c4-85d7-aafb1bc5ae64/" />
        <PFormationSectionBanche
          instance-class="p-formation-section-banche--p51"
          paragraph="Les [ctr C] / [ctr V] à répétition et prises de rendez-vous manuelles sont des tâches parasites pour lesquelles un robot ferait tout aussi bien que vous. Afin de libérer du temps, plusieurs <strong>tâches du business developer</strong> peuvent être <strong>automatisées</strong>. Loin de la doctrine “le temps c’est de l’argent”, nous pensons tout de même que les tâches les plus redondantes peuvent être automatisées pour laisser plus de temps à la gestion stratégique ou aux actions dans lesquelles le contact humain est essentiel."
          title="Le business development s’optimise et s’automatise"
          picture="https://ucarecdn.com/5563f3fc-f7a8-4bb6-a056-a4f489d5ef75/" />
        <PFormationSectionBleu
          instance-class="element-11--p51"
          paragraph="Hummmm, évidement : ÇA N’EXISTE PAS !<br> <br>Pour suivre <strong>l'évolution</strong> et les <strong>progrès</strong> de votre stratégie <strong>commerciale</strong>, il est essentiel de lister des <strong>KPI</strong> à suivre. Le suivi de ces indicateurs permet de mettre en avant les étapes du processus de vente sur lesquels le taux de déperdition est trop élevé. En mettant le doigt sur une étape en particulier, il est plus simple <strong>d’établir un plan d’actions</strong> pour augmenter le taux de conversion de cette étape. <br> <br>Exemple : Dès la prise de contact par mail le taux d’ouverture n’est pas satisfaisant. À cette étape, nous pouvons identifier un certain nombre de causes qui entraîne cela. Les listes d’envoi ne sont peut-être pas assez qualifiées et donc concernées par votre sujet ? L’horaire et le jour d’envoi sont peut-être à revoir ? L’objet du mail ne parle pas du tout à votre cible ?<br> <br>À partir du moment où vous identifiez une étape à améliorer, il faut ensuite lister les potentielles <strong>optimisations</strong>. Comment savoir, parmi la liste, ce qui doit être modifié ? Rien de mieux que l’<strong>A/B testing</strong> ! Un expert spécialiste sur le sujet pourra évidemment vous délivrer SES bonnes pratiques et les choses à essayer en premier. Bien orienté et conseillé, vous pourrez ainsi tester plusieurs changements et évaluer d’après vos KPI les modifications qui impactent le taux de conversion d’une étape donnée.<br> <br>Exemple :<br>Prises de contact LinkedIn : 1000<br>Réponses : 200<br>Intéressés : 80<br>Prennent rdv sur votre agenda : 10<br>Se présentent aux rdv : 5<br>Souhaitent adhérer à votre offre : 4<br>Adhèrent réellement à votre offre : 3<br> <br>Les KPI à chaque palier nous permettent de calculer le taux de conversion de chaque étape. Chacune de ces étapes peut-être optimisée afin d’augmenter son taux de conversion. Pour cela, l’idéal est de bénéficier d’un <strong>accompagnement personnalisé</strong> qui se base sur VOTRE cible, VOS objectifs et VOTRE activité. Notre communauté d’experts regroupe des dizaines de profils en business development, le profil parfait pour vous accompagner s’y trouve sans aucun doute. Et si ce n’était pas le cas ? Si aucun profil ne correspond parfaitement à vos critères, Matchers s’engage à vous le trouver !<br> <br>Effectivement, dans notre équipe nous avons une personne spécialisée dans le sourcing d’experts de pointe. Le plus beau dans tout ça ? Cette formation en business development est éligible aux financements mutualisés dont les petites entreprises peuvent bénéficier.<br> <br><strong>0 démarches administratives</strong> et <strong>0 coût </strong>pour être accompagné sur une formation séquencée en business development."
          title="Qu’est ce qu’un business developer sans objectif ?"
          picture="https://ucarecdn.com/310d87a9-0389-4426-8c5d-db2b6115245e/" />
      </ka-container>
    </ka-container>
  </ka-container>
</template>

<route>
{
  "meta": {
    "layout": "Header:Footer"
  }
}
</route>

<script setup lang="ts">
import { generateMeta, syncPageStore } from 'kapix-components-vue3'
import { formationsBusinessDeveloper } from './store'
import BlocArgCtaRdvPedagogieMatchers from '~/components/BlocArgCtaRdvPedagogieMatchers/index.vue'
import BlocArgPasDeFraisPasDeDemarchesAdministratives from '~/components/BlocArgPasDeFrais/PasDeDemarchesAdministratives/index.vue'
import BlocPreviewProfilExpert from '~/components/BlocPreviewProfilExpert/index.vue'
import BlocReassuranceQualiopi from '~/components/BlocReassuranceQualiopi/index.vue'
import CtaProgrammeSurMesurePrendreRdv from '~/components/CtaProgrammeSurMesurePrendreRdv/index.vue'
import DropDownFormation from '~/components/DropDownFormation/index.vue'
import PFormationCriteresQualiopi from '~/components/PFormationCriteresQualiopi/index.vue'
import PFormationEntete from '~/components/PFormationEntete/index.vue'
import PFormationMatching from '~/components/PFormationMatching/index.vue'
import PFormationPourquoiSeFormer from '~/components/PFormationPourquoiSeFormer/index.vue'
import PFormationSectionBanche from '~/components/PFormationSectionBanche/index.vue'
import PFormationSectionBleu from '~/components/PFormationSectionBleu/index.vue'
import PFormationSectionVariante from '~/components/PFormationSectionVariante/index.vue'
import { appDataStore } from '~/stores'
import './style.scss'
import './style.custom.scss'


provide('$scoped', '--p51')
const appData = appDataStore()
const page = formationsBusinessDeveloper()
const props = withDefaults(defineProps<{
  seo?: Nullable<boolean>
}>(), {
  seo: true
})

syncPageStore(page)
// SEO
if (props.seo) {
  // https://github.com/vueuse/head
  useHead({
    title: computed(() => page.$title),
    htmlAttrs: { lang: appData.locale },
    meta: computed(() => generateMeta({
      title: page.$title,
      description: page.$description,
      canonicalUrl: appData.hostname,
      publishedTime: page.$publishedTime,
      modifiedTime: page.$modifiedTime,
      ...appData.twitter
    }))
  })

  useSchemaOrg([
    // https://vue-schema-org.netlify.app/api/schema/webpage.html#type-definition
    defineWebPage({
      name: page.$title,
      description: page.$description,
      inLanguage: appData.locale,
      primaryImageOfPage: appData.twitter.image,
      datePublished: page.$publishedTime
      // dateModified: page.$modifiedTime?.toISOString()
    })
  ])
}
</script>
